import {__changeRoute} from "../utils/functions";

export default {
    computed: {
        __path(){
            return this.$store.state.default.path;
        },
        __apiPath(){
            return this.$store.state.default.apiPath;
        },
        __authPath(){
            return this.$store.state.default.authPath;
        },
        __authApiPath(){
            return this.$store.state.default.authApiPath;
        },
        __afterAuthPath(){
            return this.$store.state.default.afterAuthPath;
        },
        __logo() {
            return this.$store.state.default.logo;
        },
        __isInvalid() {
            return Object.keys(this.errors.items).length
        }
    },
    methods: {
        __validate() {
            return !Object.keys(this.errors.items).length
        },
        __errorResponse(error){
            const status = error.response?.status || error.status;
            const message = error.response?.data?.message || error.message;

            if (status === 422){
                console.log(error.response.data);
            }
            if (status === 404) {
                this.__changeRoute(404);
                return;
            }
            if (status === 401) {
                window.location.reload();
                return;
            }
            this.__error(message || status);
        },
		__infoResponse(response){
            this.$store.commit('alert/view', {type: 'info', message: response.data?.message});
        },
        __warningResponse(response){
            this.$store.commit('alert/view', {type: 'warning', message: response.data?.message});
        },
        __info(message){
            this.$store.commit('alert/view', {type: 'info', message: message});
        },
        __warning(message){
            this.$store.commit('alert/view', {type: 'warning', message: message});
        },
        __error(message){
            this.$store.commit('alert/view', {type: 'error', message: message});
        },
        __confirm(fnc){
            this.$store.commit('confirm/view', fnc);
        },
        __setLoader(value) {
            this.$store.commit('setLoader', value);
        },
        __changeRoute(path = null) {
            __changeRoute(path, this.$store, this.$route, this.$router);
        },
        __editPageLink(id) {
            return this.__path + '/edit-page/' + id
        },
        __orderViewLink(id) {
            return this.__path + '/orders/' + id
        },
        __copyText(text) {
            const textArea = document.createElement("textarea");

            // Place in the top-left corner of screen regardless of scroll position.
            textArea.style.position = "fixed";
            textArea.style.top = 0;
            textArea.style.left = 0;

            // Ensure it has a small width and height. Setting to 1px / 1em
            // doesn't work as this gives a negative w/h on some browsers.
            textArea.style.width = "2em";
            textArea.style.height = "2em";

            // We don't need padding, reducing the size if it does flash render.
            textArea.style.padding = 0;

            // Clean up any borders.
            textArea.style.border = "none";
            textArea.style.outline = "none";
            textArea.style.boxShadow = "none";

            // Avoid flash of the white box if rendered for any reason.
            textArea.style.background = "transparent";

            textArea.value = text;

            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            try {
                navigator.clipboard.writeText(textArea.value);
                textArea.blur();
                this.__info('Text has been copied successful')
            } catch (err) {
                this.__error('Oops, unable to copy')
            }

            document.body.removeChild(textArea);
        },
        __changeProject(key) {
            const projectKey = key;
            const path = this.$store.state.default.path || '/';
            const expirationDate = new Date();
            expirationDate.setFullYear(expirationDate.getFullYear() + 1);
            const expires = expirationDate.toUTCString();

            document.cookie = `X-Project-Key=${projectKey}; expires=${expires}; path=${path}; secure; samesite=Lax`;
            window.axios.defaults.headers.common['X-Project-Key'] = projectKey;

            window.location = this.__afterAuthPath;
        },
    },
}
